import { c as _c } from "react/compiler-runtime";
import { useMemo } from "react";
import dayjs from "dayjs";
import { cn } from "@/lib/utils";
import { Icon } from "./icon";
export const Attachment = t0 => {
  const $ = _c(22);
  let attachment;
  let className;
  let props;
  if ($[0] !== t0) {
    ({
      className,
      attachment,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = attachment;
    $[2] = className;
    $[3] = props;
  } else {
    attachment = $[1];
    className = $[2];
    props = $[3];
  }
  let t1;
  let t2;
  if ($[4] !== attachment.updatedAt) {
    t2 = dayjs(attachment.updatedAt).fromNow();
    $[4] = attachment.updatedAt;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  t1 = t2;
  const updatedAt = t1;
  const t3 = attachment.url;
  let t4;
  if ($[6] !== className) {
    t4 = cn("relative flex cursor-alias items-center gap-5 bg-white px-4 py-3 text-sm text-slate-11 hover:bg-slate-3 active:bg-slate-4 dark:bg-slate-1 dark:hover:bg-slate-3 dark:active:bg-slate-4 max-sm:flex-wrap", className);
    $[6] = className;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  let t5;
  if ($[8] !== attachment.title) {
    t5 = <p className="overflow-ellipsis text-base text-slate-12">{attachment.title}</p>;
    $[8] = attachment.title;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  let t6;
  if ($[10] !== attachment.subtitle) {
    t6 = <p className="flex-1 overflow-ellipsis">{attachment.subtitle}</p>;
    $[10] = attachment.subtitle;
    $[11] = t6;
  } else {
    t6 = $[11];
  }
  let t7;
  if ($[12] !== updatedAt) {
    t7 = <p className="flex-shrink-0 lg:ml-auto">{updatedAt}</p>;
    $[12] = updatedAt;
    $[13] = t7;
  } else {
    t7 = $[13];
  }
  let t8;
  if ($[14] === Symbol.for("react.memo_cache_sentinel")) {
    t8 = <Icon icon="lucide:external-link" className="h-4 w-4 flex-shrink-0" />;
    $[14] = t8;
  } else {
    t8 = $[14];
  }
  let t9;
  if ($[15] !== attachment.url || $[16] !== props || $[17] !== t4 || $[18] !== t5 || $[19] !== t6 || $[20] !== t7) {
    t9 = <a {...props} href={t3} target="_blank" rel="noreferrer" className={t4}>{t5}{t6}{t7}{t8}</a>;
    $[15] = attachment.url;
    $[16] = props;
    $[17] = t4;
    $[18] = t5;
    $[19] = t6;
    $[20] = t7;
    $[21] = t9;
  } else {
    t9 = $[21];
  }
  return t9;
};